import React, { Suspense, lazy } from 'react';
import { useMousePosition } from './hooks/useMousePosition';
import TargetCursor from './components/ui/TargetCursor';
import Navigation from './components/layout/Navigation';
import Hero from './components/sections/Hero';
import Section from './components/layout/Section';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
import Skills from './components/sections/Skills';
import Generations from './components/sections/Generations';
import Contact from './components/sections/Contact';
import { SoundProvider } from './components/providers/SoundProvider';
import Footer from './components/layout/Footer';
import ErrorBoundary from './components/utils/ErrorBoundary';

const TornadoScene = lazy(() => import('./components/ui/Tornado.tsx'));

const AppContent: React.FC = () => {
  const { x, y } = useMousePosition();
  return (
  <div className="min-h-screen bg-[var(--color-background)] text-[var(--color-foreground)] scrollbar-hide">
    <div className="fixed inset-0 z-0 opacity-50">
      <Suspense fallback={<div className="w-full h-full bg-black" />}>
        <TornadoScene mouseX={x} mouseY={y} />
      </Suspense>
    </div>
    <div className="relative z-10">
      <TargetCursor />
      <Navigation />
      <main className="relative">
        <Hero />
        <Section id="projects" title="My Works">
          <Projects />
        </Section>
        <Section id="about" title="About Me">
          <About />
        </Section>
        <Section id="skills" title="My Expertise">
          <Skills />
        </Section>
        <Section id="generations" title="AI Generations">
          <Generations />
        </Section>
        <Section id="contact" title="Get In Touch">
          <Contact />
        </Section>
      </main>
      <Footer />
    </div>
  </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-space-base">
          <div className="w-16 h-16 border-4 border-electric border-t-transparent rounded-full animate-spin"></div>
        </div>
      }>
        <SoundProvider>
          <AppContent />
        </SoundProvider>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;